import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueuesFacade {
    receivingSummary$ = new BehaviorSubject<string>(
        'Received 10/56 expected orders.'
    );
    pickingSummary$ = new BehaviorSubject<string>('Picked 30/76 orders.');
    packingSummary$ = new BehaviorSubject<string>(
        'Packed 10/76 staged orders.'
    );
    replenishmentsSummary$ = new BehaviorSubject<string>(
        'Replenished 34/87 expected orders.'
    );
    cycleCountsSummary$ = new BehaviorSubject<string>('Counted 230/900 items.');
    exceptionsSummary$ = new BehaviorSubject<string>(
        'Resolved 10/56 exceptions.'
    );
}
